import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useUtmTaxonomyStore } from '@/store/utm-taxonomy-store';
import UtmZoneList from '@/components/utm/admin/zones/UtmZoneList';
import UtmZoneForm from '@/components/utm/admin/zones/UtmZoneForm';

const UtmZonesPage = () => {
  const { fetchTaxonomy, fetchZones } = useUtmTaxonomyStore();

  useEffect(() => {
    fetchTaxonomy();
    fetchZones();
  }, [fetchTaxonomy, fetchZones]);

  return (
    <Routes>
      <Route index element={<UtmZoneList />} />
      <Route path="new" element={<UtmZoneForm />} />
      <Route path=":id/edit" element={<UtmZoneForm />} />
    </Routes>
  );
};

export default UtmZonesPage;
